import {
	faCircleCheck as fasCircleCheck,
	faCircleInfo as fasCircleInfo,
	faCircleXmark as fasCircleXmark,
	faReceipt as fasReceipt,
	faTriangleExclamation as fasTriangleExclamation,
} from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBankmonitor } from "@shared/ui/fortawesome/bankmonitor";
import compact from "lodash/compact";
import type { ReactNode } from "react";
import React from "react";
import type { AlertProps as BsAlertProps } from "react-bootstrap";
import { Alert as BsAlert } from "react-bootstrap";

export const AlertHeading = BsAlert.Heading;
export const AlertLink = BsAlert.Link;

export interface AlertProps extends Omit<BsAlertProps, "size"> {
	icon?: "auto" | ReactNode;
	size?: "sm" | "" | "lg";
	// soft?: boolean;
	alignItems?: "start" | "center" | "end";
}

export const Alert = React.forwardRef<HTMLElement, AlertProps>(
	({ variant, size, icon, children, className, alignItems = "center", ...props }, _ref) => {
		let iconContent = icon;

		if (icon === "auto") {
			switch (variant) {
				case "success":
					iconContent = <FontAwesomeIcon icon={fasCircleCheck} />;
					break;
				case "warning":
					iconContent = <FontAwesomeIcon icon={fasTriangleExclamation} />;
					break;
				case "danger":
					iconContent = <FontAwesomeIcon icon={fasCircleXmark} />;
					break;
				case "info":
					iconContent = <FontAwesomeIcon icon={fasCircleInfo} />;
					break;
				case "light":
					iconContent = <FontAwesomeIcon icon={fasReceipt} />;
					break;
				case "primary":
				case "secondary":
					iconContent = <FontAwesomeIcon icon={faBankmonitor} />;

					break;

				default:
					iconContent = undefined;
			}
		}

		let content = children;

		if (iconContent) {
			content = (
				<div
					className={compact(["d-flex flex-nowrap", size === "lg" && `align-items-${alignItems}`]).join(" ")}
				>
					<div className={size === "sm" ? "pr-1 mr-1" : "pr-2 mr-2"}>
						{icon ? (
							<span className={`fa-fw${size === "lg" ? " fa-2x" : ""}${size === "sm" ? " fa-sm" : ""}`}>
								{iconContent}
							</span>
						) : (
							iconContent
						)}
					</div>
					<div>{children}</div>
				</div>
			);
		}

		const classes = compact([className, size && `alert-${size}`]).join(" ");

		return (
			<BsAlert className={classes} variant={variant} {...props}>
				{content}
			</BsAlert>
		);
	},
);
